import axios from "axios";
import moment from "moment";

export const getUrl = (url, data = {}) => {
    return axios.get(
        process.env.VUE_APP_BASE_URL + url, 
        {
            params: {
                acf_format: 'standard',
                _fields: 'id,acf',
                per_page: 100,
                page: 1,
                ...data,
            },
            headers: {
                Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`
            }
        }
    )
}

export const getPagination = (dataList, pagination, page) => {
    let pagin = {}
    pagin.total = dataList.length;
    pagin.totalPages = Math.ceil(dataList.length / pagination.per_page);
    pagin.prevPage = page > 1 ? page : "";
    pagin.nextPage = page < pagin.totalPages ? Number(page) + 1 : "";
    pagin.page = page ? page : 1
    pagin.currentPage = page ? page : 1
    return pagin
}

export const getOffsetPagination = (pagination) => {
    if(!pagination.currentPage) return 0
    return (pagination.currentPage - 1) * (pagination.per_page) + 1;
}

export const totalItem = (item, total) => {
    if(item < 0) return 0
    if(item <= total) {
      return item
    }
    return total
}

export const formatDate = (event) => {
    return moment(event.replaceAll('/', '-')).format("YYYY/MM/DD");
}

export const formatWeekDay = (event) => { 
    moment.locale('ja'); 
    const d = moment(event.replaceAll('/', '-')).format("dd"); 
    return d; 
}

export const diffDate = (event) => {
    var start = moment(event.replaceAll('/', '-'));
    var current = moment();
    return current.diff(start, 'days')
}

export const metaData = (title = '', description = '', sitename = '', type = '', img = window.location.origin +'/images/town_common_ogimage.png') => {
    const descEl = document.querySelector('head meta[name="description"]');
    const titleEl = document.querySelector('head title');
    descEl.setAttribute('content', description);
    titleEl.textContent = title;
    
    const ogtitle = document.querySelector('head meta[property="og:title"]'); 
    ogtitle.setAttribute('content', title); 

    const ogdesc = document.querySelector('head meta[property="og:description"]'); 
    ogdesc.setAttribute('content', description); 

    const ogsitename = document.querySelector('head meta[property="og:site_name"]'); 
    ogsitename.setAttribute('content', sitename); 

    const ogtype = document.querySelector('head meta[property="og:type"]'); 
    ogtype.setAttribute('content', type); 

    const ogimg = document.querySelector('head meta[property="og:image"]'); 
    ogimg.setAttribute('content', img); 

    const ogUrl = document.querySelector('head meta[property="og:url"]'); 
    ogUrl.setAttribute('content', window.location.href); 
}

export const getItemNextPrev = (dataFilter, dataCurrent ) => {
    const currentIdx = dataFilter.findIndex(item => item.id == dataCurrent)
    let result = [dataFilter[currentIdx - 1] || null, dataFilter[currentIdx + 1] || null];
    return result;
}

export const validateNumber = (number) => {
  if (/^\d+$/.test(number)) {
    return true
  }
  return false
}

export const formatUrlDetail = (img = '') => {
    if (img === false) img = '';
    img = img.replace(process.env.VUE_APP_BASE_URL_CMS, process.env.VUE_APP_BASE_URL_FE_DETAIL);
    return img;
}

export const formatNumber = (value) => {
  if (isNaN(value) || value === '' || value === null) return value;
  return Number(value).toLocaleString('en-US');
}

export const getListThemeName = (url, data = {}) => {
    return axios.get(
        process.env.VUE_APP_BASE_URL + url, 
        {
            params: {
                ...data,
            },
            headers: {
                Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`
            }
        }
    )
}

export const getPhotoList = (url, data = {}) => {
    return axios.get(
        process.env.VUE_APP_BASE_URL_V1 + url, 
        {
            params: {
                ...data,
            },
            headers: {
                Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`
            }
        }
    )
}